// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"8e9e9086","359":"5e18afa5","753":"d01585dc","907":"dfb48427","923":"e9f9b182"}[chunkId] + ".chunk.js";
};